export * from "./RecordsListPage";
export const RECORDS_TITLE = "Records";
export const linkToRecords = () => {
  return `/app/records/records`;
};
export const RECORDS_BREADCRUMB = {
  title: RECORDS_TITLE,
  path: linkToRecords,
};
